import { z } from 'zod';

/**
 * Onboarding · per-user tour state.
 *
 * `flowKey` is decided once on first fetch from the user's role.
 * `completedSteps` is a JSON array of step IDs (strings stay stable
 * across releases — they're persisted in the DB).
 */

export const flowKeySchema = z.enum(['pm', 'financeiro', 'foreman', 'generic']);
export type FlowKey = z.infer<typeof flowKeySchema>;

export const onboardingStateSchema = z.object({
  id: z.string(),
  userId: z.string(),
  flowKey: flowKeySchema,
  completedSteps: z.array(z.string()),
  dismissedAt: z.string().nullable(),
  completedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type OnboardingState = z.infer<typeof onboardingStateSchema>;

export const markStepRequestSchema = z.object({
  stepId: z.string().min(1).max(64),
});
export type MarkStepRequest = z.infer<typeof markStepRequestSchema>;
